<div class="container-fuid bg-white default-boxrounded">
    <div class="row">
        <div class="col-12 w-100">
            <h3 class="title"><span translate="Settings.OrganisationStorageSection.EnableModal.Title"></span></h3>
        </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="saveConnectionString()">
        <div class="p-4 pt-0">
            <div class="mb-3">
                <label for="connectionstring" class="form-label" translate="Settings.OrganisationStorageSection.EnableModal.ConnectionString"><app-info-button labelName="Settings.OrganisationStorageSection.EnableModal.ConnectionStringTooltip" [url]="BlobStorageUrl"></app-info-button></label>
                <textarea class="form-control" id="connectionstring" formControlName="connectionstring" rows="3" [(ngModel)]="blobstorageConnectionstring"></textarea>
            </div>

            <div class="col-12 mt-4 pb-2 d-table w-100">
                <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="back()" translate="Button.Back"></button></span>
                <span class="float-end" *ngIf="!blobstorageConnectionstringActive"><button type="submit" id="buttonSave" class="btn btn-sm btn-primary" [disabled]="!form.valid" translate="Button.Enable"></button></span>
                <span class="float-end" *ngIf="blobstorageConnectionstringActive"><button type="submit" id="buttonSave" class="btn btn-sm btn-primary" [disabled]="!form.valid" translate="Button.SaveChanges"></button></span>
            </div>
        </div>
    </form>
</div>